import { useEffect } from "react";
import jsonFromDocument from "cerulean/src/JsonFromDocument";
import { useNotificationContext } from "cerulean/src/NotificationContext";

export function FlashMessagesHandler() {
  /**
   * Reads Django flash messages from the DOM and sends them as notifications.
   * This is intended to be used once at the root of the app, just in case there are flash messages
   * in the initial page load.
   */

  const { sendNotification } = useNotificationContext();

  useEffect(() => {
    const messages = jsonFromDocument("flash_messages", "[]");
    messages.forEach((message: { level: string; text: string }) => {
      sendNotification({
        type: mapDjangoLevelToNotificationType(message.level),
        text: message.text,
      });
    });
  }, [sendNotification]);

  return null;
}

function mapDjangoLevelToNotificationType(level: string) {
  switch (level) {
    case "success":
      return "success";
    case "error":
      return "negative";
    case "warning":
      return "negative";
    case "info":
      return "info";
    case "debug":
      return "info";
    default:
      return "info";
  }
}
